import { render, staticRenderFns } from "./QuiltyResourceTable.vue?vue&type=template&id=3dcb33b2&"
import script from "./QuiltyResourceTable.vue?vue&type=script&lang=ts&"
export * from "./QuiltyResourceTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dcb33b2')) {
      api.createRecord('3dcb33b2', component.options)
    } else {
      api.reload('3dcb33b2', component.options)
    }
    module.hot.accept("./QuiltyResourceTable.vue?vue&type=template&id=3dcb33b2&", function () {
      api.rerender('3dcb33b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/quiltyResource/QuiltyResourceTable.vue"
export default component.exports